/**
 * Keyword ranking for envelope documents.
 *
 * An admin-managed list of `keyword → position` rules (Settings). At envelope
 * creation, a document that has no position from the API request or from its
 * template takes the position of a rule whose keyword appears in its title or
 * original file name — e.g. `quote → 1` puts every uploaded quotation first.
 * The API resolves positions with this function and the admin's "test a file
 * name" box previews them with it, so the two cannot disagree.
 */
/**
 * Where a document with no position at all sits on the 1-99 scale. Deliberately
 * low: most envelopes lead with the document that matters and push boilerplate
 * (T&Cs, privacy notices) to a high number, so "unnumbered" means "before the
 * things someone explicitly pushed back", not "after everything".
 */
export const UNORDERED_DEFAULT = 3;
export const DOCUMENT_ORDER_RULE_LIMITS = { maxRules: 25, keywordMaxLength: 60 };
/**
 * The rule that positions a document, or null when no keyword matches.
 * Matching is a case-insensitive "contains" against each name, so `quote`
 * matches "Quote QU-0042.pdf" but not "Quotation.pdf". When several rules
 * match, the lowest position wins (the earliest place any rule asks for).
 */
export function matchDocumentOrderRule(rules, names) {
    const haystacks = names.filter((n) => !!n).map((n) => n.toLowerCase());
    let best = null;
    for (const rule of rules) {
        const needle = rule.keyword.trim().toLowerCase();
        if (!needle || !haystacks.some((h) => h.includes(needle)))
            continue;
        if (!best || rule.order < best.order)
            best = rule;
    }
    return best;
}
//# sourceMappingURL=document-order.js.map